import React from 'react';
import shoesHand from '../../../assets/images/occupational_theropy/shoes_hand.png';
import boyShoes from '../../../assets/images/occupational_theropy/boy_shoes.png';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';
import babyplaying from '../../../assets/images/occupational_theropy/baby_playing.webp';
const Conditions = () => {
  const images = [
    {
      src: babyplaying,
      alt: 'babyplaying sensory integration tools',
    },
    {
      src: shoesHand,
      alt: 'Wasilla therapy clinic sensory integration tools',
    },
    {
      src: boyShoes,
      alt: 'Wasilla occupational therapy fine motor activity kit',
    },
  ];

  const checklistItems = [
    'Autism Spectrum Disorder (ASD)',
    'Sensory Processing Disorders',
    'Developmental Delays',
    'Attention-Deficit/Hyperactivity Disorder (ADHD)',
    'Genetic Disorders',
    'Motor Coordination Disorders',
  ];

  return (
    <main className="relative max-w-[1200px] mx-auto h-full px-4 md:px-2 py-8 md:py-24 xl:py-28 3xl:py-36 z-10">
      <div className="flex flex-col lg:flex-row gap-10 mt-10 sm:mt-20">
        <div className="flex-1 flex flex-col gap-6 sm:gap-10">
          <CrossFadeImageSlider
            width="w-full lg:w-[600px] 2xl:w-[600px]"
            height="h-[300px] sm:h-[400px] md:h-[500px]"
            images={images}
          />
        </div>

        <div className="flex-1 rounded-3xl">
          <h4 className="text-[30px] sm:text-[35px] lg:text-[55px]  text-[#7E4B9D] font-bold leading-[40px] sm:leading-[55px] lg:leading-[65px] max-w-[700px]">
            Conditions addressed by Occupational Therapy
          </h4>
          <ul className="list-disc ml-6 sm:pl-10 py-4 sm:py-6">
            {checklistItems.map((item, index) => (
              <li
                className="text-[22px] md:text-[24px] text-[#7E4B9D] font-bold leading-tight mt-4 sm:mt-6"
                key={index}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </main>
  );
};

export default Conditions;
